const currentDate = () => {
  const now = new Date()
  const d = now.getDate()
  const m = now.getMonth() + 1
  const y = now.getFullYear()
  return `${y}-${(m < 10 ? "0" : "") + m}-${(d < 10 ? "0" : "") + d}`
}

export default currentDate
